import React from "react";
import { ReactComponent as SuspectedImg } from "../../../assets/illustrations/kyc-suspected-240x240.svg";
import ServicesLayout from "../../../layouts/Services.layout";

export const VerificationSuspectedPage: React.FC = () => {
  return (
    <ServicesLayout
      image={<SuspectedImg />}
      title="Additional verification needed"
    >
      <div className="text-base theme-text-secondary">
        Unfortunately we have been unable to complete your verification and your
        account needs to be verified by our security team. It takes up to 24
        hours to verify your account by our security team
      </div>
    </ServicesLayout>
  );
};
